import { render, staticRenderFns } from "./RequiredAmountContainer.vue?vue&type=template&id=5a65d976&scoped=true&"
import script from "./RequiredAmountContainer.vue?vue&type=script&lang=ts&"
export * from "./RequiredAmountContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65d976",
  null
  
)

export default component.exports